import type { PageCode } from '@gov-nx/module/page';
import { useCmsStorePage } from '@gov-nx/store';

export interface CmsPageProps {
	code: PageCode;
}

export const useCmsPage = (props: CmsPageProps) => useCmsStorePage(props.code);
